export default __webpack_public_path__ + "static/media/Black pearl3.c80dbf4d.jpg";